/**
 * BrowserLayout - Shared wrapper for all Starter Kit browser sub-pages
 *
 * Provides consistent layout with back navigation, title, description,
 * and a content slot for page-specific content (SOP, Policy, RACI,
 * Use Case, and Playbook browsers).
 *
 * @version 1.0.0
 * @date 2026-03-26
 */

import React from 'react';
import { Link } from 'react-router-dom';
import './starter-kit.css';

interface BrowserLayoutProps {
  title: string;
  description: string;
  children: React.ReactNode;
}

export const BrowserLayout: React.FC<BrowserLayoutProps> = ({ title, description, children }) => (
  <div className="browser-layout">
    <Link to="/starter-kit" className="browser-back-link">
      <span className="back-arrow">&larr;</span> Back to Starter Kit
    </Link>
    <div className="browser-header">
      <h1>{title}</h1>
      {description && <p className="browser-description">{description}</p>}
    </div>
    <div className="browser-content">
      {children}
    </div>
  </div>
);

export default BrowserLayout;
